<template>
    <img
        v-if="medal"
        :src="medal.src"
        :alt="medal.alt"
        class="places-medal"
    />
    <span v-else-if="displayText">{{ displayText }}</span>
    <span v-else>—</span>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    place: {
        type: [String, Number],
        default: null,
    },
});

const MEDALS = {
    '1': { src: '/images/icons/medal-gold.svg', alt: '1 место' },
    '2': { src: '/images/icons/medal-silver.svg', alt: '2 место' },
    '3': { src: '/images/icons/medal-bronze.svg', alt: '3 место' },
};

const normalizedPlace = computed(() => {
    if (props.place === null || props.place === undefined) {
        return '';
    }

    return String(props.place).trim();
});

const medal = computed(() => MEDALS[normalizedPlace.value] ?? null);

const displayText = computed(() => {
    if (!normalizedPlace.value) {
        return '';
    }

    if (medal.value) {
        return '';
    }

    return normalizedPlace.value;
});
</script>

<style scoped>
.places-medal {
    width: 30px;
    height: 30px;
    display: block;
    object-fit: contain;
}
</style>
